import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Form, Input, Button, Tabs, message } from 'antd';
import { useState } from 'react';
import { post } from '../../../axios/axios';

const LoginModal = NiceModal.create(() => {
    const modal = useModal();
    const [activeTab, setActiveTab] = useState('login');
    const [loginLoading, setLoginLoading] = useState(false);
    const [registerLoading, setRegisterLoading] = useState(false);
    const [loginForm] = Form.useForm();
    const [registerForm] = Form.useForm();

    // 登录处理
    const handleLogin = async (values) => {
        try {
            setLoginLoading(true);
            const res = await post('/member/commission/login', {
                username: values.username,
                password: values.password,
            });

            if (res && res.code === 0) {
                // 将token保存为Commission-Token格式保存到localStorage
                const userInfo = {
                    'Commission-Token': res.data.token,
                    userId: res.data.userId,
                    username: res.data.username,
                    exclusiveCode: res.data.exclusiveCode,
                    ...res,
                };
                window.localStorage.setItem('CommissionUserInfo', JSON.stringify(userInfo));
                message.success('登录成功');
                modal.resolve(userInfo);
                modal.hide();
            }
        } catch (error) {
            console.error('登录失败:', error);
            // 错误信息已经在axios拦截器中通过message.error显示了
        } finally {
            setLoginLoading(false);
        }
    };

    // 注册处理
    const handleRegister = async (values) => {
        if (values.password !== values.confirmPassword) {
            message.error('两次输入的密码不一致');
            return;
        }

        try {
            setRegisterLoading(true);
            const res = await post('/member/commission/register', {
                username: values.username,
                password: values.password,
            });

            if (res && res.code === 0) {
                // 将token保存为Commission-Token格式保存到localStorage
                const userInfo = {
                    'Commission-Token': res.data.token,
                    userId: res.data.userId,
                    username: res.data.username,
                    exclusiveCode: res.data.exclusiveCode,
                    ...res,
                };
                window.localStorage.setItem('CommissionUserInfo', JSON.stringify(userInfo));
                message.success('注册成功');
                // 注册成功后直接登录（因为接口说明返回token可直接使用）
                modal.resolve(userInfo);
                modal.hide();
            }
        } catch (error) {
            console.error('注册失败:', error);
            // 错误信息已经在axios拦截器中通过message.error显示了
        } finally {
            setRegisterLoading(false);
        }
    };

    // 关闭弹窗
    const handleCancel = () => {
        modal.reject();
        modal.hide();
    };

    const tabItems = [
        {
            key: 'login',
            label: '登录',
            children: (
                <Form form={loginForm} onFinish={handleLogin} layout="vertical">
                    <Form.Item
                        name="username"
                        label="账号"
                        rules={[{ required: true, message: '请输入账号' }]}
                    >
                        <Input placeholder="请输入账号" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="密码"
                        rules={[{ required: true, message: '请输入密码' }]}
                    >
                        <Input.Password placeholder="请输入密码" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" block loading={loginLoading}>
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            ),
        },
        {
            key: 'register',
            label: '注册',
            children: (
                <Form form={registerForm} onFinish={handleRegister} layout="vertical">
                    <Form.Item
                        name="username"
                        label="账号"
                        rules={[
                            { required: true, message: '请输入账号' },
                            { min: 3, message: '账号至少3个字符' },
                        ]}
                    >
                        <Input placeholder="请输入账号" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="密码"
                        rules={[
                            { required: true, message: '请输入密码' },
                            { min: 6, message: '密码至少6个字符' },
                        ]}
                    >
                        <Input.Password placeholder="请输入密码" />
                    </Form.Item>
                    <Form.Item
                        name="confirmPassword"
                        label="确认密码"
                        dependencies={['password']}
                        rules={[
                            { required: true, message: '请再次输入密码' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两次输入的密码不一致'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password placeholder="请再次输入密码" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" block loading={registerLoading}>
                            注册
                        </Button>
                    </Form.Item>
                </Form>
            ),
        },
    ];

    return (
        <Modal
            title="登录/注册"
            open={modal.visible}
            onCancel={handleCancel}
            footer={null}
            width={400}
            destroyOnClose
        >
            <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
        </Modal>
    );
});

export default LoginModal;
